// Components
import TextComponent from '@/components/text/component'
import Frames from '@/components/frames/component'

export default {
  name: 'frames',
  components: { TextComponent, Frames },
  data () {
    return {
    }
  },
  mounted () {
    this.$store.dispatch('trackViewFrames', {
      list: 'frames',
      frames: this.frames
    })
  },
  computed: {
    frames () {
      const ret = []
      let metadata = this.$store.getters.productsMetadata
      Object.entries(metadata).forEach((item) => {
        if (item[1].type === 'frame' || item[1].type === 'hanger') {
          ret.push(item[1])
        }
      })
      return ret
    }
  },
  methods: { }
}



// WEBPACK FOOTER //
// ./src/pages/frames/script.js